import ListNakalaKafla from "./ListNakalaKafala";

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getNakaLaData } from "../../../../store/Api";
import { setBreadCrumb } from "../../../../store/userSlice";

export default function NakalaKafala() {
  const nakaData = useSelector((state) => state.nakaLaData);
  const dispatch = useDispatch();
  //screen Title Show fun
  const titleBorder = [
    { label: "Nakal Kafala", link: "/dashboard/NakalaKafala" },
  ];
  useEffect(() => {
    dispatch(setBreadCrumb(titleBorder));
  }, []);

  const [loading, setLoading] = useState({
    updateData: false,
    uploadFile: false,
    listData: false,
    loadingId: "",
  });
  const token = localStorage.getItem("nodeToken");

  // useEffect(() => {
  //   dispatch(getNakaLaData(token));
  // }, []);

  const updateData = () => {
    dispatch(getNakaLaData(token));
  };
  return (
    <>
      <div className={`ml-5 mr-5`}>
        <ListNakalaKafla
          list={nakaData}
          loading={loading}
          titles={[
            "S.NO.",
            "EMPLOYEE ID",
            "New Employee ID",
            "EMPLOYEE NAME",
            "Company Sponsor ID",
            "CLIENT",
            "VISA SPONSOR NAME (CURRENT)",
            "IQAMA NUMBER",
            "PASSPORT NUMBER",
            "ACTUAL PROFESSION",
            "IQAMA PROFESSSION",
            // "CURRENT PROFESSION LEVEL",
            "Application Date",
            "CHANGE FEE",
            "STATUS",
            "QIWA FORM",
            "",
          ]}
          token={token}
          apiCall={updateData}
        />
      </div>
    </>
  );
}
